module.exports = __webpack_public_path__ + "img/img_mobile_occupation_dao.2bac111b.jpg";